import * as Sentry from "@sentry/angular";
import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter, Router, withComponentInputBinding} from '@angular/router';
import Aura from '@primeng/themes/aura';
import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import {BcGqlModule} from '@betterchains/bc-gql';
import {provideHttpClient} from '@angular/common/http';
import {definePreset} from '@primeng/themes';
import {environment} from '../environments/environment';
import {DialogService, DynamicDialogModule} from 'primeng/dynamicdialog';
import {AppDialogService} from './services/AppDialogService';
import {MessageService} from 'primeng/api';
import {FieldService} from './services/FieldService';
import {CalculationService} from './services/CalculationService';
import {ScheduleService} from './services/ScheduleService';
import {NgFormsRenderModule} from '@betterchains/forms-render';
import {provideTransloco} from '@ngneat/transloco';
import {InlineLoader} from './transloco-loader';
import {FieldValidationService} from './services/FieldValidationService';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    }
  }
});

const availableLangs = ['en', 'he'/*, 'ru', 'ro', 'fr', 'es'*/, 'ua']

let defaultLang = 'en';
// const l = navigator.language
// if(l.length >= 2) {
//   const _l = navigator.language.substring(0,2).toLowerCase();
//   if(availableLangs.includes(_l)) {
//     defaultLang = _l;
//   }
// }
// // defaultLang = 'he'
// console.log('defaultLang', defaultLang);

export const formsBuilderAppConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes,withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(),
    importProvidersFrom(DynamicDialogModule),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          // If you want to completely disable dark mode based on system preferences
          darkModeSelector: false // or 'none'
        }
      }
    }),
    BcGqlModule.forRoot({
      apiUrl: environment.api,
      isLocalhost: environment.local,
      staticUrl: environment.cdn
    }).providers,
    provideTransloco({
      config: {
        availableLangs,
        defaultLang,
        fallbackLang: 'en',
        prodMode: environment.production,
        reRenderOnLangChange: true,
        missingHandler: {
          allowEmpty: false,
          logMissingKey: !environment.production,
        }
      },
      loader: InlineLoader
    }),
    NgFormsRenderModule.forRoot({
      isLocalhost: environment.local,
      apiUrl: environment.api,
      staticUrl: environment.cdn,
      isApp: false
    }).providers,
    AppDialogService,
    CalculationService,
    DialogService,
    FieldService,
    FieldValidationService,
    MessageService,
    ScheduleService
  ]
};
